
import math  from "../../utils/math.js";
 
import * as THREE from "../../../../libs/three.js/build/three.module.js"; 
 
export default class HandleSvg extends THREE.EventDispatcher{
    constructor(position, color){
        super()
        this.position = position
		this.color = '#'+new THREE.Color(color).getHexString()
        this.svg = this.create() 
        this.visible_ = true  
        
        let update = ()=>{
            this.update()
        }
        viewer.addEventListener("camera_changed", update)
        
        this.addEventListener('dispose', ()=>{ 
            viewer.removeEventListener("camera_changed",  update)  
        })
    }
    
    
    create(){
        
        const svgns = "http://www.w3.org/2000/svg";
		const svg = document.createElementNS(svgns, "svg");

		svg.setAttribute("width", "2em");
		svg.setAttribute("height", "2em");
		svg.setAttribute("position", "absolute");

		svg.style.left = "50px";
		svg.style.top = "50px";
		svg.style.position = "absolute";
		svg.style.zIndex = "10000";
        svg.style.cursor = 'grab'
        svg.style.transform = 'translate(-50%,-50%)'
        
		const circle = document.createElementNS(svgns, 'circle');
		circle.setAttributeNS(null, 'cx', "1em");
		circle.setAttributeNS(null, 'cy', "1em");
		circle.setAttributeNS(null, 'r', "0.5em");
		circle.setAttributeNS(null, 'style', 'fill: '+this.color+'; stroke: black; stroke-width: 0.2em;' );
		svg.appendChild(circle);
         
		const element = viewer.renderer.domElement.parentElement;
		element.appendChild(svg);


		const startDrag = (evt) => {
            /* if(evt.button === THREE.MOUSE.RIGHT){
                return
            } */
			this.selectedElement = svg;

			document.addEventListener("mousemove", drag);
		};

		const endDrag = (evt) => {
			this.selectedElement = null;

			document.removeEventListener("mousemove", drag);
		};

		const drag = (evt) => {
			if (this.selectedElement) {
                 
				evt.preventDefault();

				const rect = viewer.renderer.domElement.getBoundingClientRect();

				const x = evt.clientX - rect.x;
				const y = evt.clientY - rect.y;

				const {width, height} = viewer.renderer.getSize(new THREE.Vector2());
				const camera = viewer.scene.getActiveCamera();
				 
                const projected = this.position.clone().project(camera);
          

				projected.x = ((x / width) - 0.5) / 0.5;
				projected.y = (-(y - height) / height - 0.5) / 0.5;

				const unprojected = projected.clone().unproject(camera);
				this.position.set(unprojected.x, unprojected.y, unprojected.z);
                
                this.update()
                this.dispatchEvent({type:'dragged', position: this.position})
                
			}
		};

		svg.addEventListener('mousedown', startDrag);
		svg.addEventListener('mouseup', endDrag);
        svg.style.display = this.visible ? "" : "none" 
         
        
        this.addEventListener('dispose',()=>{
            svg.removeEventListener('mousedown', startDrag);
            svg.removeEventListener('mouseup', endDrag); 
        })
        
        
        
        return svg
    }
    
    
    
   
   
    set visible(v){
        this.visible_ = v  
        if(v){
            this.update()
        }else{
            this.svg.style.display = "none"
        } 
    }
    get visible(){
        return this.visible_ 
    }
   
   
    update(){
        if(!this.visible)return
        
        let camera = viewer.scene.getActiveCamera() 
          
        
        var p = Potree.Utils.getPos2d( this.position, viewer.mainViewport, viewer.renderArea);
        if(!p.trueSide){
            return this.svg.style.display = 'none'; 
        }
        this.svg.style.left =  p.posInViewport.x  
        this.svg.style.top = p.posInViewport.y 
          
        
         
        this.svg.style.display = ''
            
    }
    
    
    
    dispose(){
        this.svg.remove()
        this.dispatchEvent('dispose')
    }
}

 	